module.exports = __webpack_public_path__ + "img/cash.ad2c040f.svg";